import { render, staticRenderFns } from "./ProposalShippingRouterView.vue?vue&type=template&id=e21d8394&"
import script from "./ProposalShippingRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalShippingRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports